export default class extends Controller {
  static targets = ["withoutEndButton", "withEndButton", "dateField"];

  connect() {
    App.addHandlers(this.element);
    this.updateRepeatEndsType();
  }

  setRepeatEndsTypeToTrue() {
    this.hasEndDate = true;
  }

  setRepeatEndsTypeToFalse() {
    this.hasEndDate = false;
  }

  updateRepeatEndsType() {
    this.hasEndDate = !!this.date;
  }

  //
  // GETTERS AND SETTERS
  //

  set hasEndDate(val) {
    this[`with${val ? "" : "out"}EndButtonTarget`].checked = true;
    this.dateFieldTarget.disabled = !val;
  }

  get date() {
    return this.dateFieldTarget.value;
  }
};



// WEBPACK FOOTER //
// ./app/components/repeatables/assets/javascript/repeatables-repeat-ends-on-form-fields-controller.js